import type { PageDefinition } from '@wix/thunderbolt-becky-types'
import type { VsmContext, MasterPageConfigEntry, MasterPageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { ReporterMasterPageConfig } from '../types'
import { name } from '../symbols'

const reporterMasterPageConfig: MasterPageConfigFn<ReporterMasterPageConfig> = ({ api }: VsmContext) => {
	const pageItems = api.components.getDataItemsByType<PageDefinition['data']>('Page')
	const appPages: ReporterMasterPageConfig['appPages'] = {}

	for (const [id, pageData] of Object.entries(pageItems)) {
		const tpaPageId = (pageData as { tpaPageId?: string }).tpaPageId
		if (!tpaPageId) continue
		const managingAppDefId = (pageData as { managingAppDefId?: string }).managingAppDefId
		appPages[id] = {
			appDefId: managingAppDefId ?? '',
			tpaPageId,
		}
	}

	return { appPages }
}

export const masterPageConfig: MasterPageConfigEntry<ReporterMasterPageConfig> = {
	name,
	configFactory: reporterMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
